module.exports = __webpack_public_path__ + "static/img-3-6ad040fa05f07664631388ef140e21d7.jpg";